import { useEffect, useState, useContext, useCallback } from "react";
import { queryUserInfo } from '../js/request';
import { Context } from '../js/constant';
import { setUserInfoAction } from '../actions';

interface IUserInfoType {
  mobile: string,
  nickName: string,
  plateNo: string,
}

export default function useQueryUserInfoHook() {
  const { dispatch } = useContext(Context);
  const [userInfo, setUserInfo] = useState<IUserInfoType>({
    mobile: '',
    nickName: '',
    plateNo: '',
  });

  const loadIndexData = useCallback(() => {
    queryUserInfo()
      .then(ret => {
        const { data } = ret;
        setUserInfo(data);
        dispatch(setUserInfoAction(data));
      })
  }, [dispatch])

  useEffect(() => {
    loadIndexData();
  }, [loadIndexData])

  return {
    userInfo,
  }
}